import type { Subject } from "./roll_and_post";

// Whose roll the bar's own Rolar is, on a page whose bar has no sheet of its own (the encounter's: the open card's participant).
// The island registers a resolver read at each roll, so the card that is open then is the one that rolls; null when none is.
let resolver: (() => Subject | null) | null = null;

export const barSubject = () => resolver?.() ?? null;

export function setBarSubject(value: (() => Subject | null) | null) {
	resolver = value;
}
